import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { FormikProps } from "formik";
import BaseAgreementsForm from "./base-agreement-form";
import BaseAgreementItems from "./base-agreement-item";
import { IBaseAgreementItem } from "src/interface/IBaseAgreementItem";
import { BaseAgreeType } from "src/interface/enum/BaseAgreeType";
import BaseAgreementFollowups from "./base-agreement-followups";
import { IBaseAgreementFollowup } from "src/interface/IBaseAgreementFollowup";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TabBase({
  formik,
  baseAgreementItems,
  baseAgreementFollowups,
  setBaseAgreementItem,
  setBaseAgreementFollowups,
}: {
  formik: FormikProps<any>;
  baseAgreementItems: IBaseAgreementItem[];
  baseAgreementFollowups: IBaseAgreementFollowup[];
  setBaseAgreementItem: React.Dispatch<
    React.SetStateAction<IBaseAgreementItem[]>
  >;
  setBaseAgreementFollowups: React.Dispatch<
    React.SetStateAction<IBaseAgreementFollowup[]>
  >;
}) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="مشخصات پایه قرار داد" {...a11yProps(0)} />
          <Tab label="پیگیری اقساط" {...a11yProps(1)} />
          <Tab label="نوع فعالیت" {...a11yProps(2)} />
          <Tab label="نوع شخصیت" {...a11yProps(3)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <BaseAgreementsForm formik={formik} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <BaseAgreementFollowups
          setRows={setBaseAgreementFollowups}
          rows={baseAgreementFollowups}
          key={"type"}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <BaseAgreementItems
          baseAgreeType={BaseAgreeType.TypeActivity}
          setRows={setBaseAgreementItem}
          rows={baseAgreementItems}
          key={"type"}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <BaseAgreementItems
          baseAgreeType={BaseAgreeType.TypeService}
          setRows={setBaseAgreementItem}
          rows={baseAgreementItems}
          key={"volume"}
        />
      </CustomTabPanel>
    </Box>
  );
}
